"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./CollapsibleContainer.css");
/**
 * @see CollapsibleContainerProps
 */
var CollapsibleContainer = /** @class */ (function (_super) {
    __extends(CollapsibleContainer, _super);
    function CollapsibleContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            height: '0px'
        };
        return _this;
    }
    CollapsibleContainer.prototype.componentDidMount = function () {
        if (this.contentRef) {
            this.setState({
                height: this.contentRef.clientHeight + 'px'
            });
        }
    };
    CollapsibleContainer.prototype.componentDidUpdate = function () {
        var height = this.contentRef.clientHeight + 'px';
        if (this.state.height !== height) {
            this.setState({ height: height });
        }
    };
    CollapsibleContainer.prototype.render = function () {
        var _this = this;
        var mainClasses = ['p-collapsible-container'];
        var expandedStyles = {
            height: this.props.isOpen ? this.state.height : '0px',
            transitionDuration: '.5s',
            visibility: this.props.isOpen ? 'visible' : 'hidden'
        };
        if (this.props.maxHeight) {
            expandedStyles['maxHeight'] = this.props.maxHeight;
            expandedStyles['overflowY'] = 'auto';
        }
        if (this.props.transitionSpeed) {
            expandedStyles.transitionDuration = this.props.transitionSpeed;
        }
        this.props.isOpen ? mainClasses.push('p-expanded-is-open') : mainClasses.push('p-expanded-is-closed');
        return (React.createElement("div", { className: mainClasses.join(' '), "data-tag": this.props.tag || null, style: expandedStyles, "aria-hidden": !this.props.isOpen },
            React.createElement("div", { className: "expanded-content", ref: 
                /* istanbul ignore next */ function (ref) {
                    _this.contentRef = ref;
                } }, this.props.children)));
    };
    CollapsibleContainer.defaultProps = {
        transitionSpeed: '.5s',
        maxHeight: ''
    };
    return CollapsibleContainer;
}(React.Component));
exports.default = CollapsibleContainer;
//# sourceMappingURL=CollapsibleContainer.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/collapsible-container/build/control/CollapsibleContainer.js
// module id = 901
// module chunks = 0